import { db } from "@/firebase";
import { initialBusinessLines } from "./initial_business_lines";

export async function addBusinessLine(businessLine) {
  const docRef = await db.collection("businessLines").add(businessLine);
  return docRef.id;
}

export async function setBusinessLine(id, businessLine) {
  await db
    .collection("businessLines")
    .doc(id)
    .set(businessLine);
}

export async function getBusinessLines() {
  const businessLines = [];

  const querySnapshot = await db.collection("businessLines").get();

  if (querySnapshot.empty) {
    for (const businessLine of initialBusinessLines) {
      const {
        id,
        type,
        name,
        legacyName,
        value,
        isOem,
        isHidden,
        parents,
        customizations
      } = businessLine;

      const data = {
        type,
        name,
        legacyName,
        value,
        isOem: Boolean(isOem),
        isHidden: Boolean(isHidden),
        parents,
        customizations
      };

      try {
        await setBusinessLine(id, data);
        businessLines.push({
          id,
          ...data
        });
      } catch (error) {
        console.error(error);
      }
    }

    return businessLines.filter(businessLine => !businessLine.isHidden);
  }

  querySnapshot.forEach(doc => {
    const data = doc.data();

    if (data.isHidden) {
      return;
    }

    businessLines.push({
      id: doc.id,
      ...data
    });
  });

  const businessLinesList = businessLines.length ? businessLines : [];

  // Sort aplhabetically
  const sortedBusinessLines = businessLinesList.sort((a, b) => {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();

    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;

    return 0;
  });

  return sortedBusinessLines;
}

export const getBusinessLineName = type => {
  const entryType = {
    businessLine: {
      name: "1. Business Line"
    },
    marketSegment: {
      name: "2. Market Segment"
    },
    application: {
      name: "3. Application"
    }
  };

  if (!type || !entryType[type]) {
    console.error(`getBusinessLineName: invalid type ${type}`);

    return "";
  }

  return entryType[type].name;
};

export const getBusinessLineListEntry = ({
  id,
  type,
  name,
  legacyName,
  value,
  isOem,
  isHidden,
  parents,
  customizations
}) => {
  return {
    id,
    type,
    typeName: getBusinessLineName(type),
    name,
    legacyName,
    value,
    isOem,
    isHidden,
    parents,
    customizations
  };
};
